export enum UserStatusDto {
    Inactive = 'Inactive',
    Active = 'Active',
    Blocked = 'Blocked',
    Archived = 'Archived',
    Suspended = 'Suspended',
}
